// Third party.
require('./partials/modernizr.js');
var AOS = require('./partials/aos');
var $ = window.jQuery;

// Default functionality for navigation/search etc.
var navigation = require('./sections/navigation.js')($, Modernizr);
var search = require('./sections/search.js')($);
var timeline = require('./sections/timeline.js')($);
import Modal from './partials/modal.js';

// Default functionality for each section required on the website.
import { heroBanner, imageSlider, customSlider } from './sections/banner.js';
import tabs from './sections/tabbed-content';
import { footer } from './sections/footer';
import { resources } from './sections/resources';
import faqs from './sections/faqs';
import products from './sections/product';
import productStickyMenu from './partials/page-sticky-menu';

$(document).ready(function() {
  let overlay = document.querySelectorAll('.overlay')
  overlay.forEach((field, i) => {
    field.style.marginBottom = '-130px'
    field.style.paddingBottom = '0'
    let nextElement = field.nextElementSibling
    nextElement.style.paddingTop = '200px'
  });
    /**
     * Search functionality
     *
     */
    const searchContainer = document.getElementById('search-main');
    const searchInputs = document.querySelectorAll('.search-inputs input');
    const searchToggleBtns = document.querySelectorAll('button[data-action="search-toggle"]');
    const searchTypeSelects = document.querySelectorAll('.current-search-type select');

    // Toggle search section display status
    searchToggleBtns.forEach( button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            searchContainer.classList.toggle('opacity-0');
            searchContainer.classList.toggle('-translate-y-80');
            searchContainer.classList.toggle('-z-10');
            // searchContainer.classList.toggle('opacity-100');

            //  Keep the active state styles applied when search is active
            if( e.currentTarget.id === 'desktop-search-toggle' ) {
                e.currentTarget.parentElement.classList.toggle('bg-white');
                e.currentTarget.classList.toggle('text-white');
            }
        })
    })

    // Update the placeholder attribute
    // Placeholder text is added to a data attribute so it can be translated
    searchTypeSelects.forEach( (select, i) => {
        select.addEventListener('change', function(e) {
            searchInputs.forEach((input, i) => {
                const searchType = select.value === '_s' ? 'all' : select.value;
                const placeholderText = input.dataset[`ph${searchType.charAt(0).toUpperCase() + searchType.slice(1)}`];
                input.setAttribute('placeholder', placeholderText);
            })
        });
    });


    /**
     * Custom functionality and overrides.
     */

    // init banners and sliders
    if( document.querySelector('.banner-slide-container.init-tinyslider') !== null ) {
        heroBanner({
            container: '.banner-slide-container.init-tinyslider'
        });
    }
    if( document.querySelector('.image-slider.init-tinyslider') !== null ) {
        const imageSliders = document.querySelectorAll('.image-slider.init-tinyslider');

        imageSliders.forEach(slider => {
            let settings = {
                container: slider,
                autoplay: false,
                center: true,
                controls: true,
                gutter: 16,
                items: 1,
                loop: false,
                nav: false,
                mouseDrag: true,
                controlsContainer: ".image-slider--controls",
            }

            if( slider.dataset.nav === "true" ) {
                settings['nav'] = true;
                settings['navPosition'] = 'bottom'
            }

            imageSlider(settings);
        })
    }
    if( document.querySelector('.image-slider-small.init-tinyslider') !== null ) {
        const imageSliders = document.querySelectorAll('.image-slider-small.init-tinyslider');

        imageSliders.forEach(slider => {
            let settings = {
                container: slider,
                autoplay: false,
                center: true,
                controls: false,
                gutter: 16,
                items: 1,
                loop: false,
                nav: false,
                mouseDrag: true,
            }

            if( slider.dataset.nav === "true" ) {
                settings['nav'] = true;
                settings['navPosition'] = 'bottom'
            }

            imageSlider(settings);
        })
    }
    if( document.querySelector('.slider.slider-col-3.init-tinyslider') !== null) {

        customSlider({
            container: '.slider-col-3.init-tinyslider',
            gutter: 20,
            items: 1,
            loop: false,
            nav: true,
            navPosition: 'bottom',
            controls: false,
            mouseDrag: true,
            responsive: {
                480: {
                    items: 2,
                    controls: true
                },
                768: {
                    items: 3,
                    controls: true
                }
            }
        })
    }
    if( document.querySelector('.slider.slider-col-4.init-tinyslider') !== null) {

        customSlider({
            container: '.slider-col-4.init-tinyslider',
            controlsContainer: '.slider--controls',
            gutter: 20,
            items: 2,
            loop: false,
            nav: false,
            controls: false,
            mouseDrag: true,
            responsive: {
                768: {
                    items: 3,
                    controls: true
                },
                1024: {
                    items: 4,
                    gutter: 60
                }
            }
        })
    }
    if( document.querySelector('.slider.slider-col-1.slider-nav.init-tinyslider') !== null) {
        let slidersCol1 = document.querySelectorAll('.slider.slider-col-1.slider-nav.init-tinyslider');

        slidersCol1.forEach(slider => {
            let sliderContainer = slider.closest('.slider-container');
            let sliderNav = sliderContainer.querySelector('.slider--nav');
            customSlider({
                container: slider,
                navContainer: sliderNav,
                items: 1,
                loop: true,
                nav: true,
                controls: false,
                mouseDrag: true,
            })
        })
    }
    if( document.querySelector('.slider.slider-quotes.init-tinyslider') !== null) {
        let slidersQuote = document.querySelectorAll('.slider.slider-quotes.init-tinyslider');

        slidersQuote.forEach(slider => {
            let sliderNav = slider.querySelector('.slider-quote--nav');
            let sliderControls = slider.querySelector('.slider-quote--controls');
            customSlider({
                container: slider,
                navContainer: sliderNav,
                controlsContainer: sliderControls,
                items: 1,
                loop: true,
                nav: true,
                controls: false,
                mouseDrag: true,
                autoplay: false,
                center: true
            })
        })
    }
    if( document.querySelector('.post-list--container.init-tinyslider') !== null ) {
        let postSlider = document.querySelector('.post-list--container.init-tinyslider');

        customSlider({
            container: postSlider,
            items: 1,
            loop: false,
            nav: true,
            navPosition: 'bottom',
            controls: false,
            mouseDrag: true,
            autoplay: false,
            responsive: {
                480: {
                    items: 2,
                    gutter: 20
                },
                1024: {
                    items: 3
                },
                1280: {
                    items: 4,
                    control: false,
                    nav: false,
                }
            }
        })
    }
    if( document.querySelector('.product-slider.init-tinyslider') !== null ) {
        let productSliders = document.querySelectorAll('.product-slider.init-tinyslider');


        productSliders.forEach(slider => {

            customSlider({
                autoplay: false,
                container: slider,
                controls: false,
                items: 1,
                loop: false,
                mouseDrag: true,
                nav: true,
                navPosition: 'bottom',
                responsive: {
                    480: {
                        items: 2,
                        gutter: 20
                    },
                    768: {
                        items: 3
                    },
                    1024: {
                        items: 4,
                        control: false,
                        nav: false,
                    }
                }
            })
        });
    }
    if( document.querySelector('.single-post-gallery.init-tinyslider') !== null) {

        customSlider({
            container: '.single-post-gallery.init-tinyslider',
            controls: false,
            items: 1,
            loop: false,
            mouseDrag: true,
            nav: true,
            navContainer: '.single-post-gallery-nav',
        })
    }
    if( document.querySelector('.slider-logo.init-tinyslider') !== null) {

        customSlider({
            container: '.slider-logo.init-tinyslider',
            controls: false,
            gutter: 20,
            items: 2,
            loop: false,
            mouseDrag: true,
            nav: true,
            navPosition: 'bottom',
            responsive: {
                768: {
                    items: 3,
                    controls: true
                },
                1024: {
                    items: 4,
                    gutter: 60
                }
            }
        })
    }
    if( document.querySelector('.featured-posts-slider.init-tinyslider') !== null) {

        customSlider({
            autoplay: false,
            container: '.featured-posts-slider.init-tinyslider',
            controls: false,
            items: 1,
            loop: false,
            mouseDrag: true,
            navPosition: 'bottom',
            slideBy: 'page'
        })
    }

    if( document.querySelector('.accessory-list-slider.init-tinyslider') !== null) {

        let accessorySliders = document.querySelectorAll('.accessory-list-slider.init-tinyslider');

        accessorySliders.forEach(slider => {

            let items = slider.dataset.columns;

            customSlider({
                autoplay: false,
                container: slider,
                controls: false,
                controlsContainer: slider.nextElementSibling,
                items: 1,
                gutter: 20,
                loop: false,
                mouseDrag: true,
                nav: true,
                navPosition: 'bottom',
                responsive: {
                    768: {
                        items: 2
                    },
                    1024: {
                        items: items
                    },
                    1140: {
                        controls: true,
                    }
                }
            })

        });
    }

    AOS.init();

    // Modal init
    Modal.init({
        elem: 'body'
    })

    tabs.init();
    faqs.init();
    products.init();

    // Show or hide Share Options on product pages
    var shareBtn        = document.getElementById('show-share-options');
    var shareContainer  = document.getElementById('share-options');
    if( shareBtn !== null ) {
        shareBtn.addEventListener( 'click', function(e) {
            e.preventDefault();

            shareContainer.classList.toggle('scale-100');
            shareContainer.classList.toggle('opacity-100');
        })
    }

    // Add sticky bar to bottom of product page
    productStickyMenu.init('.single-product');

    // resources
    resources($);

});

footer();
